import { ChannelFeedChannel } from './interfaces';

const MAX_FEATURED_TALENTS = 3;

type ChannelDescriptionData = Pick<ChannelFeedChannel, 'category' | 'featured_talents' | 'mediumDescription'>;

export function resolveChannelDescription(channel: ChannelDescriptionData): string {
    if (channel.category !== 'music') {
        return channel.mediumDescription;
    }

    const featuredTalentNames = channel.featured_talents?.visible
        ? channel.featured_talents.talents
              .slice(0, MAX_FEATURED_TALENTS)
              .map(({ name }) => name)
              .filter((name): name is string => Boolean(name))
              .join(', ')
        : undefined;

    return featuredTalentNames || channel.mediumDescription;
}
